<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <DownloadReport/>
    <PageHero image="cr-hero.jpg">
      <TextHeading variant="subtitle">Policy</TextHeading>
      <TextHeading variant="xl">
        Responsible business
        <br>practices & policies
      </TextHeading>
      <BaseButton class="mt-10 text-primary" rounded="full" variant="white" width="small">
        <BaseIcon name="arrow_downward" size="22"></BaseIcon>
      </BaseButton>
    </PageHero>
    <PageGrid>
      <PageMain>
        <PageSection>
          <Cards cols="4">
            <CardsCol>
              <CardLink
                title="Single carrier bag usage is down by 80%"
                link="Carrier bag charging"
                category="Programmes"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Campylobacter results below the 7% FSA target"
                link="Campylobacter Update"
                category="Programmes"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Championing British Farming"
                link="Farming Programme"
                category="Programmes"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Single carrier bag usage is down by 80%"
                link="Carrier bag charging"
                category="Programmes"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Single carrier bag usage is down by 80%"
                link="Carrier bag charging"
                category="Programmes"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Campylobacter results below the 7% FSA target"
                link="Campylobacter Update"
                category="Programmes"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Championing British Farming"
                link="Farming Programme"
                category="Programmes"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Single carrier bag usage is down by 80%"
                link="Carrier bag charging"
                category="Programmes"
              ></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import PageGrid from '../elements/PageGrid.vue'
import CardLink from '../components/CardLink.vue'
import CardsCol from '../elements/CardsCol.vue'
import PageHero from '../components/PageHero.vue'
import TheFooter from '../components/TheFooter.vue'
import Cards from '../elements/Cards.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import TextHeading from '../elements/TextHeading.vue'
import DownloadReport from '../components/DownloadReport.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'CorporateResponsabilityPolicy',
  components: {
    TheHeader,
    BreadcrumbBar,
    DownloadReport,
    TextHeading,
    PageMain,
    PageSection,
    Cards,
    CardLink,
    TheFooter,
    PageHero,
    CardsCol,
    PageGrid,
    BaseButton,
    BaseIcon
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>